import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { scrollToFragment } from '../utils/scroll-to-fragment';

@Component({
  selector: 'app-tariffs-redirect',
  standalone: true,
  template: '',
})
export class TariffsRedirectComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.navigate(['/'], { fragment: 'tariffs', replaceUrl: true }).then(() => {
      scrollToFragment('tariffs');
    });
  }
}
